import { createRouter, createWebHistory, type RouteRecordRaw } from 'vue-router'
import DemoView from '@/views/DemoView.vue'

const routes: RouteRecordRaw[] = [
  {
    path: '/',
    name: 'demo',
    component: DemoView,
  },
  {
    path: '/editor/login',
    name: 'editor-login',
    component: () => import('@/views/EditorLoginView.vue'),
  },
  {
    path: '/editor',
    name: 'editor',
    component: () => import('@/views/EditorView.vue'),
    meta: { requiresEditorAuth: true },
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: '/',
  },
]

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
  scrollBehavior: () => ({ top: 0 }),
})

router.beforeEach(async (to) => {
  if (!to.meta.requiresEditorAuth) return true

  const { useEditorAuthStore } = await import('@/stores/editorAuth')
  const auth = useEditorAuthStore()

  if (auth.isAuthenticated) return true

  return {
    name: 'editor-login',
    query: { redirect: to.fullPath },
  }
})

export default router